export default "__VITE_ASSET__EOr$iQtw__"